/*
  For the lottie animations that will be used across the site.
*/

// eslint-disable-next-line import/prefer-default-export
export const getAnimationPath = (animationPath) =>
  `/static/animations/${animationPath}`;
